var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"16","viewBox":"0 0 20 12"}},[_c('path',{attrs:{"fill":"#4A4A4A","fill-rule":"evenodd","d":"M0 0h20v2.191H0zm0 7.591V5.452h20v2.14H0zm0 5.452v-2.19h20v2.19z"}})])
}
var staticRenderFns = []

export default { render: render }